import { ReactElement } from 'react'
import classNames from 'classnames'

import './SegmentTabs.scss'

export interface SegmentTabOption<Value extends string> {
    value: Value
    label: string
    description?: string
}

interface SegmentTabsProps<Value extends string> {
    name: string
    label: string
    options: SegmentTabOption<Value>[]
    value: Value
    disabled?: boolean
    onChange: (value: Value) => void
    className?: string
}

export const SegmentTabs = <Value extends string>({
    name,
    label,
    options,
    value,
    disabled,
    onChange,
    className = '',
}: SegmentTabsProps<Value>): ReactElement => (
    <fieldset className={`segment-tabs ${className}`} disabled={disabled}>
        <legend className="segment-tabs__legend">{label}</legend>

        {options.map(option => (
            <label
                key={option.value}
                className={classNames('segment-tabs__tab', {
                    'segment-tabs__tab--is-active': option.value === value,
                })}
            >
                <input
                    type="radio"
                    name={name}
                    value={option.value}
                    checked={option.value === value}
                    onChange={() => onChange(option.value)}
                    className="segment-tabs__input"
                />
                <span className="segment-tabs__label">{option.label}</span>
                {option.description && (
                    <span className="segment-tabs__description">{option.description}</span>
                )}
            </label>
        ))}
    </fieldset>
)
